import angular from 'angular';
import cmsACL from '../../ACL/ACLService';

/**
 * @memberOf cms.input.text
 * @property {object}   bindings.errors     Form errors object
 * @property {string}   bindings.model      Input value reference
 * @property {string}   bindings.title      Input title and/or placeholder
 * @property {function} bindings.onBlur     Function called on input blur event
 * @property {function} bindings.onChange   Function called on input change event
 */
let cmsInputOptions = {
    bindings: {
        errors: '<',
        model: '=',
        label: '@',
        aclShow: '<?',
        aclDisable: '<?',
        labelSize: '@',
        inputSize: '@',
        placeholder: '@'
    },
    template: require('./options.html'),
    controller: function() {
        this.removeOption = (object) => {
            this.model.splice(object.key, 1);
        };

        this.addOption = (object) => {
            if(this.model) {
                this.model.splice(object.key + 1, 0, '');
            } else {
                this.model = ['']
            }
        }
    }
};

/**
 * Options control
 * @namespace cms.input.options
 */
export default angular.module('cms.input.options', [cmsACL]).component('cmsInputOptions', cmsInputOptions).name;




// WEBPACK FOOTER //
// ./src/cmsCore/Controls/OptionsControl/CmsInputOptions.js